export function formatDuration(totalSeconds: number): string {
  const s = Math.max(0, Math.round(totalSeconds));
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);
  const sec = s % 60;
  if (h > 0) return `${h}h ${m.toString().padStart(2, '0')}m`;
  if (m > 0) return `${m}m ${sec.toString().padStart(2, '0')}s`;
  return `${sec}s`;
}

export function formatClock(totalSeconds: number): string {
  const m = Math.floor(totalSeconds / 60);
  const s = totalSeconds % 60;
  return `${m}:${s.toString().padStart(2, '0')}`;
}

export function formatPercent(value: number): string {
  return `${Math.round(value * 1000) / 10}%`;
}

export function formatNumber(value: number): string {
  return value.toLocaleString('en-US');
}

export function formatMinutes(minutes: number): string {
  const m = Math.max(0, Math.round(minutes));
  const h = Math.floor(m / 60);
  const r = m % 60;
  return h > 0 ? `${h}h ${r.toString().padStart(2, '0')}m` : `${r}m`;
}

/** Minutes as hh:mm, e.g. 402 → "06:42"; long totals keep growing hours ("312:15") */
export function formatHhMm(minutes: number): string {
  const m = Math.max(0, Math.round(minutes));
  return `${Math.floor(m / 60).toString().padStart(2, '0')}:${(m % 60).toString().padStart(2, '0')}`;
}

/** Relative change, e.g. 0.12 for +12% */
export function relativeChange(current: number, previous: number): number {
  if (previous === 0) return current === 0 ? 0 : 1;
  return (current - previous) / previous;
}

function sign(v: number): string {
  return v > 0 ? '+' : v < 0 ? '−' : '';
}

export function formatSignedPercent(change: number): string {
  const v = Math.round(change * 1000) / 10;
  return `${sign(v)}${Math.abs(v)}%`;
}

/** Difference between two rates, in percentage points */
export function formatSignedPts(diff: number): string {
  const v = Math.round(diff * 1000) / 10;
  return `${sign(v)}${Math.abs(v)} pts`;
}

export function formatSignedNumber(diff: number): string {
  return `${sign(diff)}${formatNumber(Math.abs(Math.round(diff * 10) / 10))}`;
}

export function answerRateTone(rate: number): string {
  if (rate >= 0.9) return 'text-positive';
  if (rate >= 0.75) return 'text-warning';
  return 'text-danger';
}

export function initials(name: string): string {
  return name
    .split(' ')
    .map((p) => p[0])
    .join('')
    .slice(0, 2)
    .toUpperCase();
}
